exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1gjOnviSVp-BXI{display:flex;flex-direction:column;height:100%}._1gjOnviSVp-BXI._2Hjz0p7fH_i3le{margin-left:280px}._1gjOnviSVp-BXI>#header,._1gjOnviSVp-BXI>.header-banner{flex:none}._1gjOnviSVp-BXI #content{flex-grow:1}", ""]);

// exports
exports.locals = {
	"surface": "_1gjOnviSVp-BXI",
	"pinnedBoardsMenu": "_2Hjz0p7fH_i3le"
};